<mat-toolbar
  color="primary"
  class="heigh-toolbar"
  fxLayout.xs="row"
  fxLayoutAlign.xs="space-between center"
>
  <div class="logo-type" fxLayoutAlign="space-between center">
    <button class="btn-menu" mat-icon-button (click)="toggleSidebar()">
      <mat-icon class="icon-color">menu</mat-icon>
    </button>
    <img alt="" class="logo" src="assets/images/logos/log_logo.svg" />
    <div
      *ngIf="renderLeadsBack"
      fxHide.lg
      fxHide.xl
      class="centered"
      routerLink="/main/leads"
      style="padding-top: 12px;"
    >
      <mat-icon class="icon-back" style="color: #ccc !important">
        keyboard_backspace
      </mat-icon>
    </div>
    <label
      for="activeView"
      class="ml-2 blue-color font-weight-bold align-bottom"
      [ngClass]="{ 'mr-2': summaryView }"
      [ngStyle.xs]="{ 'font-size': '17px' }"
      [ngStyle.sm]="{
        'margin-top': '5px',
        'letter-spacing': '1px'
      }"
    >
      {{ activeView | titlecase }}
      <ng-container *ngIf="summaryView">({{ summaryView }}) </ng-container>
    </label>
    <mat-divider
      [vertical]="true"
      *ngIf="summaryView"
      class="d-inline align-bottom"
      [ngClass]="{ 'ml-2': !summaryView }"
    ></mat-divider>
    <label
      class="ml-2 align-bottom"
      style="color: #535353;font-weight: bold;"
      *ngIf="activeView && paymentSummary"
    >
      Total: {{ paymentSummary | currency }} USD
    </label>
  </div>
  <div
    class="time-text"
    fxHide.xs
    *ngIf="activeView == 'Dashboard' && user && user.role.name !== 'fronter'"
    fxLayout="row"
  >
    <mat-icon
      svgIcon="select_dashboard"
      style="height: 20px !important;    margin-top: 10px;
      margin-right: 7px;"
      *ngIf="user && user.role.name == 'super_admin'"
    ></mat-icon>
    <app-switch-dashboard fxFlex></app-switch-dashboard>
  </div>
  <div fxFlex="20" class="container-search-global my-auto" tabindex="-1">
    <!-- *ngIf="user.role.name === 'fronter'" -->
    <app-global-search></app-global-search>
  </div>
  <span class="example-fill-remaining-space" fxHide.xs></span>
  <div
    fxLayout="row"
    [ngClass]="{
      'sub-container-tool-sales':
        user && ['sales_rep', 'sales_manager'].includes(user.role.name),
      'sub-container-tool':
        user && !['sales_rep', 'sales_manager'].includes(user.role.name)
    }"
  >
    <button
      mat-flat-button
      aria-label="Reports"
      (click)="openDownloadReportsModal()"
      *ngIf="this.userPermission && this.userPermission.reports"
      style="
        height: 35px;
        background: #025bb8;
        color: white;
        margin-top: 4px;
        margin-right: 120px
      "
    >
      Download Reports
    </button>
    <app-short-actions></app-short-actions>
    <div class="notifications">
      <button
        mat-icon-button
        aria-label="Notifications"
        (click)="
          showNotify = !showNotify;
          notificationsSummary = 0;
          resetStoreNotifications()
        "
      >
        <mat-icon
          [class.seen]="notificationsSummary == 0"
          matBadge="{{ notificationsSummary }}"
          matBadgeColor="warn"
          style="color: #969696;"
          >notifications_none</mat-icon
        >
        <div
          class="container-notifications arrow-top text-left"
          *ngIf="showNotify"
        >
          <app-notifications
            [notifications]="notifications"
            (currentNotifications)="setNotification($event)"
            [storePendingNotifications]="storePendingNotifications"
            [openNotifictionsFirstTime]="openNotifictionsFirstTime"
            [opened]="showNotify"
          ></app-notifications>
        </div>
      </button>
    </div>
    <div
      class="username-container"
      [matMenuTriggerFor]="menu"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      [ngStyle.xs]="{ 'margin-left': '-20px' }"
    >
      <img
        class="avatar-profile-header ml-3"
        onerror="this.src='../../../assets/images/icons/user.png';this.style='opacity:0.3';"
        src="{{ resourcesUrl + user.photo }}"
        alt="Avatar photo"
      />

      <span class="username ml-1" fxShow fxHide.xs
        >{{ user.name }} {{ user.last_name }}</span
      >
      <mat-icon style="color: gray">keyboard_arrow_down</mat-icon>
    </div>
  </div>
  <mat-menu #menu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="settings()">
      <mat-icon>settings</mat-icon>
      <span>Settings</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>
</mat-toolbar>
